import { STORIES } from "../data/site";
import { Reveal, Label, BookButton } from "../components/ui-kit";

export default function Stories() {
  return (
    <>
      <section className="pt-40 pb-16 bg-black" data-testid="stories-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Label>Success Stories</Label>
          <h1 className="font-display uppercase text-white text-5xl md:text-8xl leading-[0.9] mt-6 max-w-4xl">Proof that everyday people do extraordinary things.</h1>
        </div>
      </section>

      <section className="bg-black pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {STORIES.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div className="rounded-3xl overflow-hidden border border-white/10 bg-charcoal group h-full" data-testid={`story-card-${i}`}>
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" style={{ objectPosition: s.pos || "center" }} />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                </div>
                <div className="p-5">
                  <p className="font-display text-xl text-gold uppercase">{s.name}</p>
                  <p className="text-sm text-white mt-1">{s.stat}</p>
                  <p className="mt-2 text-sm text-lightgrey/80 italic">"{s.quote}"</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-black py-20 text-center">
        <div className="max-w-2xl mx-auto px-6">
          <Reveal>
            <h2 className="font-display uppercase text-white text-4xl md:text-5xl">Your story starts here.</h2>
            <div className="mt-8 flex justify-center"><BookButton testid="stories-book" /></div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
